import React, { Component } from "react";
import "./DeleteModal.css";
import { Modal, ModalHeader, ModalBody } from "reactstrap";

export default class DeleteModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      canDelete: true,
      items: this.props.item.map((row) => row.original),
      results: this.getResults(this.props.item.map((row) => row.original)),
    };
  }

  getResults = (items) => {
    let results = [];
    for (var item of items) {
      if (item.inner_nodes.length === 0) {
        results.push("Remaining");
      }
    }
    return results;
  };

  canDelete = (items) => {
    for (var item of items) {
      if (item.inner_nodes.length === 0) {
        return true;
      }
    }
    return false;
  };

  isThereDeletion = () => { 
    for (var item of this.state.items) {
      if (item.inner_nodes.length === 0) {
        return true;
      }
    }
    return false;
  };

  isThereGateways = () => {
    for (var item of this.state.items) {
      if (item.inner_nodes.length > 0) {
        return true;
      }
    }
    return false;
  };

  render() {
    const { toggle, onSave, refreshList } = this.props;

    return (
      <Modal modalClassName="Modal" isOpen={true} toggle={toggle}>
        <ModalHeader>
          {" Node Deletion "}
          <button className="delete_close_button" onClick={toggle}>
            ×
          </button>
        </ModalHeader>
        <div className="val_error_area">
          <ul style={{ color: "red" }}>{this.state.validationErrors}</ul>
        </div>
        <ModalBody>
          <div>
            {this.isThereDeletion() ? (
              <>
                Nodes to be deleted:
                <div style={{ display: "flex" }}>
                  <ul>
                    {this.state.items.map((item, index) => (
                      <>
                        {item.inner_nodes.length === 0 ? (
                          <>
                            {this.state.results[index] === "Success" ||
                            this.state.results[index] === "Failed" ? (
                              <li key={item.uuid}>
                                <b>{"Node " + item.eid + " "}</b>
                              </li>
                            ) : (
                              <li style={{ color: "red" }} key={item.uuid}>
                                {" "}
                                <b> {"Node " + item.eid + " "} </b>{" "}
                              </li>
                            )}
                          </>
                        ) : null}
                      </>
                    ))}
                  </ul>
                  <ul>
                    {this.state.items.map((item, index) => (
                      <>
                        {item.inner_nodes.length === 0 ? (
                          <>
                            {this.state.results[index] === "Success" ? (
                              <div
                                key={"delete_" + item.uuid}
                                style={{ color: "rgb(30, 210, 0)" }}
                              >
                                <b>Deleted</b>
                              </div>
                            ) : (
                              <>
                                {this.state.results[index] === "Failed" ? (
                                  <div
                                    key={"delete_" + item.uuid}
                                    style={{ color: "rgb(30, 210, 0)" }}
                                  >
                                    <b>Failed</b>
                                  </div>
                                ) : (
                                  <>
                                    {this.state.results[index] ===
                                    "Deleting" ? (
                                      <div
                                        key={"delete_" + item.uuid}
                                        style={{ color: "white" }}
                                      >
                                        <b>Deleting...</b>
                                      </div>
                                    ) : (
                                      <div key={"delete_" + item.uuid}>
                                        <b> </b>
                                      </div>
                                    )}
                                  </>
                                )}
                              </>
                            )}
                          </>
                        ) : null}
                      </>
                    ))}
                  </ul>
                </div>
              </>
            ) : null}
            {this.isThereGateways() ? (
              <>
                Gateway nodes cannot be deleted. Delete their children first:
                <ul>
                  {this.state.items.map((item, index) => (
                    <>
                      {item.inner_nodes.length > 0 ? (
                        <li key={item.uuid}>
                          <b>{"Node " + item.eid}</b>
                        </li>
                      ) : null}
                    </>
                  ))}
                </ul>
              </>
            ) : null}
          </div>

          <div className="button_area">
            <button
              className="delete_button"
              disabled={this.state.loading}
              onClick={async () => {
                if (!this.canDelete(this.state.items) || this.state.isDone) {
                  toggle();
                  return;
                }
                this.setState({ loading: true });
                this.setState({ validationErrors: [] });
                let valid = true;
                let i = 0;
                for (var item of this.state.items) {
                  if (item.inner_nodes.length === 0) {
                    let results = this.state.results;
                    results[i] = "Deleting";
                    this.setState({ results });
                    let status = await onSave(item);
                    valid = valid && status;
                    if (status) {
                      results[i] = "Success";
                    } else {
                      results[i] = "Failed";
                    }
                    this.setState({ results });
                  }
                  i += 1;
                }
                this.setState({ isDone: true });
                this.setState({ loading: false });
                if (valid) {
                  refreshList(null);
                }
              }}
            >
              {this.state.loading
                ? "Loading..."
                : this.canDelete(this.state.items) && !this.state.isDone
                ? "Delete"
                : "Exit"}
            </button>
          </div>
        </ModalBody>
      </Modal>
    );
  }
}
